import React from 'react';
import { Typography, Card, Row, Col, Anchor } from 'antd';
import { useTranslation } from 'react-i18next';
import { FileTextOutlined } from '@ant-design/icons';
import SEO from '../../components/SEO';
import './TermsPage.css';

const { Title, Paragraph } = Typography;

const TermsPage: React.FC = () => {
  const { t } = useTranslation('landing');

  const renderList = (key: string) => {
    const items = t(key, { returnObjects: true }) as string[];
    return (
      <ul>
        {items.map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <SEO
        title="Условия использования QATE | Пользовательское соглашение платформы"
        description="Условия использования платформы управления тестированием QATE. Правила и требования для пользователей, права и обязанности, ограничения использования сервиса."
        keywords="условия использования QATE, пользовательское соглашение, terms of service, правила использования, лицензия, QA платформа"
        canonicalUrl="/terms"
        ogTitle="Условия использования QATE"
        ogDescription="Условия использования платформы управления тестированием QATE. Правила и требования для пользователей."
        noIndex={true}
        schema={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Условия использования",
          "description": "Пользовательское соглашение и условия использования платформы QATE",
          "isPartOf": {
            "@type": "WebSite",
            "name": "QATE",
            "url": "https://qate.ru"
          }
        }}
      />
      <div className="terms-page">
        <div className="terms-container">
          <Card className="terms-card">
            <Title level={1}>{t('terms.title')}</Title>
            <Paragraph>{t('terms.lastUpdated')}</Paragraph>

            <Title level={2}>{t('terms.acceptance.title')}</Title>
            <Paragraph>{t('terms.acceptance.content')}</Paragraph>

            <Title level={2}>{t('terms.service.title')}</Title>
            <Paragraph>{t('terms.service.content')}</Paragraph>
            {renderList('terms.service.items')}

            <Title level={2}>{t('terms.license.title')}</Title>
            <Paragraph>{t('terms.license.content')}</Paragraph>

            <Title level={2}>{t('terms.responsibilities.title')}</Title>
            <Paragraph>{t('terms.responsibilities.content')}</Paragraph>
            {renderList('terms.responsibilities.items')}

            <Title level={2}>{t('terms.feedback.title')}</Title>
            <Paragraph>{t('terms.feedback.content')}</Paragraph>
            {renderList('terms.feedback.items')}

            <Title level={2}>{t('terms.disclaimer.title')}</Title>
            <Paragraph>{t('terms.disclaimer.content')}</Paragraph>

            <Title level={2}>{t('terms.limitations.title')}</Title>
            <Paragraph>{t('terms.limitations.content')}</Paragraph>
            {renderList('terms.limitations.items')}

            <Title level={2}>{t('terms.modifications.title')}</Title>
            <Paragraph>{t('terms.modifications.content')}</Paragraph>

            <Title level={2}>{t('terms.termination.title')}</Title>
            <Paragraph>{t('terms.termination.content')}</Paragraph>

            <Title level={2}>{t('terms.data.title')}</Title>
            <Paragraph>{t('terms.data.content')}</Paragraph>

            <Title level={2}>{t('terms.revisions.title')}</Title>
            <Paragraph>{t('terms.revisions.content')}</Paragraph>

            <Title level={2}>{t('terms.contact.title')}</Title>
            <Paragraph>{t('terms.contact.content')}</Paragraph>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TermsPage; 